import { Box, Typography } from '@mui/material';
import { FC, PropsWithChildren, ReactNode } from 'react';
import {
  OC_DEFINE_ROW_LABEL_SX,
  OC_DEFINE_ROW_SX,
  OC_DEFINE_ROW_VALUE_SX,
} from '@/theme/au-compat';

interface Props extends PropsWithChildren {
  label: ReactNode;
}

/** `.oc-define-row` del espécimen DPG `55fd83a`: etiqueta a la izquierda, valor como chip `subtle`. */
export const DisplayBox: FC<Props> = ({ label, children }) => {
  return (
    <Box sx={OC_DEFINE_ROW_SX}>
      <Typography sx={OC_DEFINE_ROW_LABEL_SX}>{label}</Typography>
      <Typography sx={OC_DEFINE_ROW_VALUE_SX}>{children}</Typography>
    </Box>
  );
};
